import {
  AppLayout,
  ContentLayout,
  BreadcrumbGroupProps,
  AppLayoutProps,
} from '@cloudscape-design/components';
import { useContext } from 'react';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import { useNavigate } from '@tanstack/react-router';

import { NavigationContext } from '../common/navigation';
import { DashboardSideNavigation } from '../common/navigation/dashboard-navigation';

const HOME = { text: 'Dashboard', href: '/dashboard' };

function DashboardBreadcrumbs({ items }: { items: BreadcrumbGroupProps.Item[] }) {
  const navigate = useNavigate();

  return (
    <BreadcrumbGroup
      items={[HOME, ...items]}
      onClick={(event) => {
        if (event.detail.external) {
          return;
        }
        event.preventDefault();
        navigate({ to: event.detail.href });
      }}
    />
  );
}

export type DashboardViewLayoutProps = {
  header?: React.ReactNode;
  secondaryHeader?: React.ReactNode;
  breadcrumbs?: BreadcrumbGroupProps.Item[];
  children: React.ReactNode;
  contentType?: AppLayoutProps.ContentType;
  navigationHide?: boolean;
  headerVariant?: 'default' | 'high-contrast';
  maxContentWidth?: number;
};

export function DashboardViewLayout(props: DashboardViewLayoutProps) {
  const { navigationSize, navigationOpen, setNavigationOpen } = useContext(NavigationContext);

  return (
    <AppLayout
      breadcrumbs={props.breadcrumbs ? <DashboardBreadcrumbs items={props.breadcrumbs} /> : undefined}
      className="app-layout"
      headerVariant={props.headerVariant}
      content={
        <ContentLayout
          header={props.header}
          secondaryHeader={props.secondaryHeader}
          headerVariant={props.headerVariant}
        >
          {props.children}
        </ContentLayout>
      }
      contentType={props.contentType ?? 'default'}
      headerSelector=".top-navigation"
      navigation={<DashboardSideNavigation />}
      navigationOpen={navigationOpen}
      navigationWidth={navigationSize}
      navigationHide={props.navigationHide}
      toolsHide
      onNavigationChange={(event) => setNavigationOpen(event.detail.open)}
      maxContentWidth={props.maxContentWidth}
    />
  );
}
